/**
 * Adds the Save Form for Later Button in the IME form footer.
 */
export function addSaveFormInFooter() {
	const saveButton = document.querySelector( '.js-save-temp-form' );
	const formFooter = document.querySelector( '.gform_page_footer' );

	if ( !saveButton || !formFooter ) {
		return;
	}

	const newSaveButton = saveButton.cloneNode( true );
	formFooter.appendChild( newSaveButton );
}